import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function AgentList(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [sharePercent, setSharePercent] = useState(25);

    useEffect(() => {
      setLoading(true);
      
      var user = util.getTrustedUser();
      var params = {login:user, searchText:"", agentCode:0, lastIndex:0, pageSize:0};
      var url = config.Server+`/user/agent/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  for(var i=0;i<response.length;i++) response[i]["isActive"] = response[i].user.isActive;
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }, []);

    const onRowEditClick = function(row) {
      setCurrentItem(row);
      setSharePercent(row.sharePercent);
      setEditFormVisible(true);        
    }

    const closeEditDialog = function(){
      setEditFormVisible(false);
    }

    const checkDataEntry = function(){
        if(sharePercent <= 0){
            setErrorMessage("سهم نماینده فروش را مشحص کنید");
            setErorVisible(true);
            return false;
        } 

        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var params = {login:util.getTrustedUser(), id:id, sharePercent:sharePercent};
      var url = config.Server+`/user/agent/detail/update`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {...response};
                        tmp[i].isActive = tmp[i].user.isActive;
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "sharePercent") {
            if(val == null) val = "0";
            if(val == "") val = "0";
            setSharePercent(parseInt(val));
        }
    }
    const setNewState = function(row, isActive){
      var params = {login:util.getTrustedUser(), nationalId:row.user.nationalId, isActive:isActive};
      var url = config.Server+`/user/set/active-state`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  console.log("start finding agent")
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === row.id){
                      tmp[i] = {user:response, isActive:isActive, sharePercent:tmp[i].sharePercent, province:tmp[i].province, city:tmp[i].city, address:tmp[i].address}
                      tmp[i].user.isActive = isActive;
                      tmp[i].isActive = isActive;

                      setCurrentItem(tmp[i]);
                      console.log("agent founded", tmp[i])
                      break;
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
          });
    }
    const setRowActions = function(row) {
      if(row.user.isActive){
        return(
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-power-off" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => setNewState(row, false)} title="غیر فعال گردد" />
            </Row>
        )
      }
      else{
        return(
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-power-off" rounded severity="primary" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => setNewState(row, true)} title="فعال شود" />
            </Row>
        )
      }
    }
    const showUserState = function(row){
      if(row.user.isActive){
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
        )
      }
      else{
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
        )
      }
    }
    return(      
      <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>لیست نمایندگان فروش</div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>          
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>
                
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field="user.nationalId" body={(row)=>row.user.nationalId} header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                        <Column field="user.firstname" body={(row)=>row.user.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                        <Column field="user.lastname" body={(row)=>row.user.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                        <Column field="user.mobile" body={(row)=>row.user.mobile} header={"موبایل"} sortable className="list-cell-text-align"></Column>
                        <Column field="province" header={"استان"} sortable className="list-cell-text-align"></Column>
                        <Column field="city" header={"شهر"} sortable className="list-cell-text-align"></Column>
                        <Column field="sharePercent" header={"درصد سهم"} sortable className="list-cell-text-align"></Column>
                        <Column field="user.agentCode" body={(row)=>row.user.agentCode} header={"کد"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row)=>showUserState(row)} header={"وضعیت"} className="list-cell-text-align"></Column>
                        <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
                </DataTable>
                
              </>
          }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت مشخصات نماینده" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={sharePercent} onChange={(e)=>{onInputChange(e, "sharePercent")}}  keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">درصد سهم نماینده</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr><td>&nbsp;</td></tr>
                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      </>  
    );
}
